import { ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { brandConfig } from "../../../config/brand";
import { Button } from "../ui/Button";

export function PublicHeader() {
  const { pathname } = useLocation();
  const isTestRoute = pathname.startsWith("/test");
  const showTestCta = pathname !== "/" && !isTestRoute;

  if (isTestRoute) return null;

  return (
    <header className="sticky top-0 z-20 border-b border-cyan-200/10 bg-slate-950/72 shadow-[0_10px_40px_rgb(0_0_0_/_0.18)] backdrop-blur-2xl">
      <div className="mx-auto flex min-h-16 w-full max-w-6xl items-center justify-between gap-3 px-4 sm:px-6">
        <Link to="/" aria-label="Αρχική Brain Test" className="flex min-w-0 items-center gap-3">
          <img src={brandConfig.logoMarkPath} alt="" className="h-9 w-9 shrink-0 object-contain" />
          <span className="truncate text-base font-bold tracking-normal">{brandConfig.brandName}</span>
        </Link>
        <nav className="hidden items-center gap-1 text-sm text-slate-300 lg:flex" aria-label="Κύρια πλοήγηση">
          <a className="rounded-xl px-3 py-2 transition hover:bg-white/8 hover:text-white" href="/#how-it-works">
            Πώς λειτουργεί
          </a>
          <a className="rounded-xl px-3 py-2 transition hover:bg-white/8 hover:text-white" href="/#faq">
            FAQ
          </a>
          <Link className="rounded-xl px-3 py-2 transition hover:bg-white/8 hover:text-white" to="/contact">
            Επικοινωνία
          </Link>
        </nav>
        {showTestCta ? (
          <div className="flex items-center gap-2">
            <Button href="/test" className="min-h-11 px-4 py-2 text-xs sm:text-sm">
              Ξεκίνα το IQ Test <ArrowRight className="ml-2 hidden sm:block" size={16} />
            </Button>
          </div>
        ) : null}
      </div>
    </header>
  );
}
